import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Organizacion } from "@/shared/types/organizacion";

export interface OrganizacionEditRequest {
    nombre: string,
}

export async function editOrganizacion(id: string, request: OrganizacionEditRequest): Promise<Organizacion> {
    await sleep(1000);
    const response = await api.put("organizaciones/" + id, request);
    return response.data;
}

export function useEditOrganizacionMutation(id: string, mutationConfig: MutationConfig<Organizacion, OrganizacionEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: OrganizacionEditRequest) => await editOrganizacion(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["organizaciones"] });
        },
    })
}

export interface EditOrganizacionMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Organizacion, OrganizacionEditRequest>,
    children?: (mutationResult: MutationResult<Organizacion, OrganizacionEditRequest>) => ReactNode
}

export function EditOrganizacionMutation({
    id,
    children,
    mutationConfig
}: EditOrganizacionMutationProps) {
    const mutationResult = useEditOrganizacionMutation(id, mutationConfig);
    return children && children(mutationResult)
}